module.exports = __webpack_public_path__ + "static/media/transporter-t5-fig-1.89b785cc.jpg";